import { MorePageContainer } from './MorePageContainer.tsx';
import { mountUIReactComponent } from '../ui_platform/mountUIReactComponent.tsx';
export function mountMorePage(containerId, onRulebookClick, options) {
    mountUIReactComponent(containerId, MorePageContainer).render({
        onRulebookClick: onRulebookClick,
        ...options
    });
}
